import { motion } from "framer-motion";
import {
  DatabaseZap,
  ScanLine,
  Bot,
  ShieldCheck,
  BarChart3,
  Sparkles,
  Users,
  Cog,
  Puzzle,
} from "lucide-react";

const SERVICES = [
  {
    icon: DatabaseZap,
    title: "Modernização de ERPs",
    desc: "Refatoração e evolução de arquiteturas legadas em Totvs Protheus, Oracle EBS, SAP B1, Logix, RM e Datasul. Do mapeamento à entrega com governança.",
    tag: "Core",
  },
  {
    icon: ScanLine,
    title: "Reforma Tributária",
    desc: "Adequação de ERPs à nova sistemática (CBS/IBS/IS), regras de crédito, layouts fiscais e simulações de impacto. Preparação de manufatura e serviços.",
    tag: "Fiscal",
  },
  {
    icon: Bot,
    title: "Automação & RPA",
    desc: "UiPath, Power Automate, Python. Eliminação de tarefas manuais no fiscal, financeiro, contas a pagar, PCP, faturamento e logística.",
    tag: "RPA",
  },
  {
    icon: Sparkles,
    title: "IA aplicada ao backoffice",
    desc: "Agentes, copilots e assistentes que resolvem dúvidas do time, geram relatórios, classificam documentos fiscais e apoiam tomadas de decisão.",
    tag: "IA",
  },
  {
    icon: BarChart3,
    title: "KPIs, Indicadores & BI",
    desc: "Desenho de indicadores acionáveis, dashboards executivos e cultura de dados para melhorar performance de operações e diretoria.",
    tag: "Dados",
  },
  {
    icon: ShieldCheck,
    title: "Compliance & Auditoria",
    desc: "SoD, trilhas, controles internos, LGPD e auditoria fiscal/manufatura. Preparação para SOX e auditorias externas.",
    tag: "Compliance",
  },
  {
    icon: Cog,
    title: "Arquitetura & Integração",
    desc: "Redesenho de arquitetura, integrações via APIs/EDI, orquestração entre ERP, WMS, MES, CRM e serviços em nuvem (Oracle Cloud, Azure).",
    tag: "Arquitetura",
  },
  {
    icon: Users,
    title: "Customer Experience",
    desc: "Melhoria da experiência do cliente interno e externo com processos enxutos, autosserviço e comunicação orientada a resultado.",
    tag: "CX",
  },
  {
    icon: Puzzle,
    title: "Soluções de Mercado integradas ao ERP",
    desc: "Tax Compliance (Tax One / Mastersaf), Soluções Folha (ADP e Senior HCM) e Logística & Supply Chain — WMS, TMS e OMS (Visio Systems e Soluções Senior GKO).",
    tag: "Soluções",
    wide: true,
  },
];

export default function Services() {
  return (
    <section id="servicos" className="relative py-28 md:py-36" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <p className="label-eyebrow">O que entregamos</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-tight tracking-tight text-white">
            Consultoria <span className="gradient-text">ponta a ponta</span> — do diagnóstico à autonomia do time.
          </h2>
          <p className="mt-6 text-lg text-[#B8C0D0] leading-relaxed">
            Frentes de trabalho que combinam profundidade técnica em ERPs com IA prática, automação, dados e mudança cultural.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mt-14" data-testid="services-grid">
          {SERVICES.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className={`card-surface p-6 group ${s.wide ? "md:col-span-2 lg:col-span-4" : ""}`}
              onMouseMove={(e) => {
                const r = e.currentTarget.getBoundingClientRect();
                e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
                e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
              }}
              data-testid={`service-card-${i}`}
            >
              <div className="flex items-start justify-between">
                <div className="w-12 h-12 rounded-lg bg-cyan-400/10 border border-cyan-400/25 flex items-center justify-center group-hover:bg-cyan-400/20 transition-colors">
                  <s.icon size={22} className="text-cyan-400" />
                </div>
                <span className="font-mono-tech text-[10px] text-cyan-400/80 tracking-widest uppercase">
                  /{s.tag}
                </span>
              </div>
              <h3 className="font-display text-xl font-semibold text-white mt-6 leading-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-sm text-[#8892B0] leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
